import React, { Component } from "react";
import { Form } from "react-form";
import { connect } from "react-redux";

import { addSmsReload } from "actions/company";
import InputText from "components/form-fields/InputText";
import { toggleFullPageSpinner, toggleNotification } from "actions/toggle";

class AddSmsReload extends Component {
  onSubmit = data => {
    const {
      match: {
        params: { companyId }
      },
      history,
      addSmsReload,
      toggleFullPageSpinner,
      toggleNotification
    } = this.props;

    addSmsReload(companyId, data)
      .then(() => {
        toggleNotification(true, {
          message: "Added SMS Reload Successfully!",
          infoClassName: "is-success"
        });
        history.push(`/companies/${companyId}/sms-reloads`);
      })
      .catch(e => {
        toggleNotification(true, {
          message: e.message,
          infoClassName: "is-danger"
        });
      })
      .then(() => toggleFullPageSpinner(false));
  };

  render() {
    const {
      props: { defaultValues }
    } = this;

    return (
      <Form onSubmit={this.onSubmit} defaultValues={defaultValues}>
        {formApi => (
          <form onSubmit={formApi.submitForm}>
            <div className="box">
              <div className="columns">
                <div className="column">
                  <InputText
                    required
                    field="amount"
                    label="Amount"
                    placeholder="Amount"
                    required
                  />
                </div>
              </div>
              <div className="columns">
                <div className="column">
                  <InputText
                    field="note"
                    label="Note"
                    placeholder="Note"
                    required
                  />
                </div>
              </div>
            </div>

            <button className="button is-fullwidth is-info is-medium">
              Submit
            </button>
          </form>
        )}
      </Form>
    );
  }
}

const mapStateToProps = ({}) => ({});

export default connect(mapStateToProps, {
  addSmsReload,
  toggleFullPageSpinner,
  toggleNotification
})(AddSmsReload);



// WEBPACK FOOTER //
// ./src/pages/Company/SmsReload/Add.js